import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  messageAuthor: {
    fontWeight: 700,
    overflowWrap: 'anywhere'
  },
  messageAvatar: {
    fontSize: '1rem',
    height: '2rem',
    width: '2rem'
  },
  messageBody: {
    whiteSpace: 'pre-line',
    wordBreak: 'break-word'
  },
  messageDetails: {
    flexWrap: 'wrap',
    gap: theme.spacing(0.5, 1),
    marginBottom: theme.spacing(0.5),
    minHeight: '1.75rem',
    width: '100%',
    '& > .MuiTypography-root': {
      marginRight: theme.spacing(1.5)
    }
  },
  messageMetadata: {
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    minWidth: 0,
    maxWidth: '100%'
  },
  kanatiRequestChip: {
    height: 'auto',
    lineHeight: '1rem',
    minHeight: '1.25rem',
    maxWidth: '100%',
    '& .MuiChip-label': {
      whiteSpace: 'normal'
    }
  },
  messageListItem: {
    alignItems: 'flex-start',
    padding: theme.spacing(1),
    width: '100%',
    '& .messageControls': {
      display: 'none'
    },
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
      borderRadius: theme.shape.borderRadius,
      '& .messageControls': {
        display: 'block'
      }
    }
  },
  messageListItemAvatar: {
    minWidth: 0
  },
  messageListItemText: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    marginLeft: theme.spacing(1.5),
    width: '100%'
  },
  messageEditorContainer: {
    position: 'relative',
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(2.5)
  },
  messageCharacterCount: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    bottom: theme.spacing(1),
    padding: theme.spacing(0, 0.5),
    pointerEvents: 'none',
    position: 'absolute',
    right: theme.spacing(1.5)
  },
  mdxEditor: {
    width: '100%'
  }
}));

export default useStyles;
